// 9fbef606107a605d69c0edbcd8029e5d
import { createSelector } from 'reselect';
import { OUTFIT_DETAILS_REDUCER_KEY } from '../../../../../constants/reducer.constants';
import { getABtestFromState } from '../../../../../utils';
import getAddedToBagFormValues from '../../../../../reduxStore/selectors/form.selectors';

export const getReduxFormState = (state) => {
  return state.form;
};

export const getOutfitImage = (state) => {
  return (
    state[OUTFIT_DETAILS_REDUCER_KEY] &&
    state[OUTFIT_DETAILS_REDUCER_KEY].currentOutfit &&
    state[OUTFIT_DETAILS_REDUCER_KEY].currentOutfit.outfitImageUrl
  );
};

export const getOutfitProducts = (state) => {
  return (
    state[OUTFIT_DETAILS_REDUCER_KEY] &&
    state[OUTFIT_DETAILS_REDUCER_KEY].currentOutfit &&
    state[OUTFIT_DETAILS_REDUCER_KEY].currentOutfit.products
  );
};

export const getOutfitId = (state) => {
  return (
    state[OUTFIT_DETAILS_REDUCER_KEY] &&
    state[OUTFIT_DETAILS_REDUCER_KEY].currentOutfit &&
    state[OUTFIT_DETAILS_REDUCER_KEY].currentOutfit.outfitId
  );
};

export const getOutfitCarouselState = (state) => {
  return state[OUTFIT_DETAILS_REDUCER_KEY] && state[OUTFIT_DETAILS_REDUCER_KEY].outfitCarouselModal;
};

export const getUnavailableCount = (state) => {
  return (
    state[OUTFIT_DETAILS_REDUCER_KEY] &&
    state[OUTFIT_DETAILS_REDUCER_KEY].currentOutfit &&
    state[OUTFIT_DETAILS_REDUCER_KEY].currentOutfit.unavailableCount
  );
};

export const getAddedToBagErrorCatId = (state) => {
  return state.AddedToBagReducer && state.AddedToBagReducer?.get('errorCatId');
};

export const getGeneralProductId = (state) => {
  return state.OutfitDetails.currentOutfit &&
    state.OutfitDetails.currentOutfit.products &&
    state.OutfitDetails.currentOutfit.products.length > 0
    ? state.OutfitDetails.currentOutfit &&
        state.OutfitDetails.currentOutfit.products &&
        state.OutfitDetails.currentOutfit.products[0].generalProductId
    : false;
};

export const getOutfitDetailFormValues = createSelector(
  [getGeneralProductId, (state) => state],
  (generalProductId, state) => {
    return generalProductId
      ? getAddedToBagFormValues(state, `ProductAddToBag-${generalProductId}`)
      : '';
  }
);

export const getLoadingState = (state) => {
  return state[OUTFIT_DETAILS_REDUCER_KEY] && state[OUTFIT_DETAILS_REDUCER_KEY].isLoading;
};

export const getOnModelImageAbTestOutfitPdp = (state) => {
  return getABtestFromState(state.AbTest).enableOnModelImageOnOutfit;
};

export const getIsOutfitAddedCTAEnabled = (state) => {
  return getABtestFromState(state.AbTest).enableOutfitAddedCTA;
};

export const getShowAddedToBagCTA = (state) => {
  return state.AddedToBagReducer && state.AddedToBagReducer.get('showAddedToBagCta');
};

export const getOutfitCarouselAddedCTA = (state) => {
  return state.AddedToBagReducer && !!state.AddedToBagReducer.get('showOutfitCarouselAddedCta');
};

export const getOutfitCache = (state) => {
  return state[OUTFIT_DETAILS_REDUCER_KEY] && state[OUTFIT_DETAILS_REDUCER_KEY].outfitCacheData;
};

export const getEntireFormValue = (state) => {
  return state?.form;
};

export const getOutfitProductSelector = createSelector([getOutfitProducts], (items) => {
  let outfitItems = [];
  if (items) {
    outfitItems = items.map((item) => ({ productId: item.generalProductId }));
  }
  return outfitItems;
});

const getOutfits = (state) => state[OUTFIT_DETAILS_REDUCER_KEY];

export const getSelectedProductList = createSelector(getOutfits, (outfits) => {
  return outfits && outfits.selectedOutfitProducts;
});

export const getCurrentOutfit = createSelector(getOutfits, (outfit) => outfit.currentOutfit);

export const getIsOutfit = createSelector(getOutfits, (outfit) => outfit?.isOutfitPage);

export const getSelectedProductId = createSelector(
  getOutfits,
  (outfit) => outfit?.selectedProductId
);
